"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.userHasDismissedSurvey = exports.setCookie = exports.getCookieName = void 0;
const js_cookie_1 = __importDefault(require("js-cookie"));
const constants_1 = require("./constants");
const getCookieName = () => `${constants_1.COOKIE.SURVEY_DISMISSED}__${window.location.pathname}`;
exports.getCookieName = getCookieName;
const setCookie = () => {
    js_cookie_1.default.set((0, exports.getCookieName)(), window.location.pathname, {
        path: window.location.origin || "",
    });
};
exports.setCookie = setCookie;
const userHasDismissedSurvey = () => js_cookie_1.default.get((0, exports.getCookieName)()) === window.location.pathname;
exports.userHasDismissedSurvey = userHasDismissedSurvey;
//# sourceMappingURL=utils.js.map